export default "__VITE_ASSET__obBhCPTV__"